import { ConsultationRequestOrderStatus } from '@enums/consultation-request-order-status';
import { Account } from '@models/account';
import { ConsultationRequest } from '@models/consultation-request/consultation-request';
import { CustomerAddressResponse } from '@models/customer-address-response';
import { CustomerTest } from '@models/customer-test';
import { OrderTest } from '@models/order-test';
import { Recharge } from '@models/recharge';
import { Subscription } from '@models/subscription';

export class ConsultationRequestOrderDetail {
  public customer_id: string;
  public account: Account;
  public address: CustomerAddressResponse;
  public email: string;
  public first_name: string;
  public last_name: string;
  public phone: string;
  public date_of_birth: Date;
  /**
   * The "tests" is deprecated. Use customer_tests instead. We need to keep this for backward compatibility.
   *
   * @Issue: https://github.com/Medology/arepa-general/issues/1436
   */
  public tests: OrderTest[];
  public customer_tests: CustomerTest[];
  public lab_order_tests: any[];
  public recharge: Recharge;
  public gender: string;
  public race: string;
  public ethnicity: string;
  public sex_with: string;
  public pregnant: string;
  public last_menstrual_date: string;
  public due_date: string;
  public symptoms: string;
  public transaction_id: string;
  public hash: string;
  public consultationRequest: ConsultationRequest;
  public anonymousToken?: string;
  public last_prescribed_at: string;
  public status: ConsultationRequestOrderStatus;
  public remaining_balance: number;
  public subscription_current_intake_url: string | null;
  public subscription: Subscription | null;

  public constructor(consultation: { [key: string]: any } = {}) {
    Object.assign(this, consultation);
    this.date_of_birth = this.parseDate(consultation.date_of_birth);
  }

  /**
   * Removes the time from the date string & parse a date string into a Date object.
   *
   * @param {string} date The date
   */
  private parseDate(date: string): Date {
    const [year, month, day] = date.split('-').map(Number);
    return new Date(year, month - 1, day);
  }
}
